import { render, staticRenderFns } from "./AdicionarUsuarioOrganizacaoModal.vue?vue&type=template&id=24a6a74b&scoped=true&"
import script from "./AdicionarUsuarioOrganizacaoModal.vue?vue&type=script&lang=js&"
export * from "./AdicionarUsuarioOrganizacaoModal.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarUsuarioOrganizacaoModal.vue?vue&type=style&index=0&id=24a6a74b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6a74b",
  null
  
)

export default component.exports